<div class="mx-5 mb-5" id="myPdf" *ngIf="deliveryRequests">
  <div
    class="mx-5 my-5 print-wrap page{{ j + 1 }}"
    id="page{{ j }}"
    *ngFor="let item of slices; let j = index"
  >
    <div class="row mx-5">
      <div class="col-6 text-left mt-5">
        <img
          class="img-fluid"
          style="width: 60%"
          src="../../../assets/img/modal/intigrow.png"
        />
        <h4>INTIGROW SA</h4>
        <p>24 rue Ibn hazem Andalousie,</p>
        <p>Menzah 6 Ariana</p>
        <p>Tél : 56 83 76 52</p>
        <p>info@intigo.tn</p>
        <p>www.intigo.tn</p>
      </div>
      <div class="col-6 text-center mt-5">
        <h3>
          {{
            transfertObject?.type == 2
              ? "Transfert Retour"
              : "Transfert Livraison"
          }}
          :
        </h3>

        <div class="text-center">
          <h6>Nom du Chauffeur: {{ transfertObject?.driver?.name }}</h6>
          <h6>Téléphone du Chauffeur: {{ transfertObject?.driver?.tel }}</h6>
          <h6 *ngIf="transfertObject?.secondDriver">Nom du deuxième Chauffeur: {{ transfertObject.secondDriver.name }}</h6>
          <h6 *ngIf="transfertObject?.secondDriver">Téléphone du deuxième Chauffeur: {{ transfertObject.secondDriver.tel }}</h6>
          <h6>Date: {{ transfertObject?.createdAt | date: "dd/MM/yyyy hh:mm" }}</h6>
          <h6>Nombre de colis: {{ deliveryRequests.length }}</h6>
          <h6>Centrale départ : {{ centraLeDepart?.name }}</h6>
          <h6>Centrale arrivé : {{ centralArrive?.name }}</h6>

          <div class="col text-center" *ngIf="jobsRequestGroupId">
            <qrcode
              [qrdata]="jobsRequestGroupId"
              [width]="qrwidth"
              [errorCorrectionLevel]="'M'"
            ></qrcode>
          </div>
        </div>
        <br />
      </div>
    </div>
    <div class="row mx-5 pb-5">
      <br />
      <br />
      <br />
      <table class="table table-striped">
        <thead class="items-header-section table-header">
          <tr>
            <th scope="col">Numéro</th>
            <th scope="col">Expéditeur</th>
            <th scope="col">N. de téléphone du expéditeur</th>
            <th scope="col">Adresse d'expéditeur</th>
            <th scope="col">Prix</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let req of slices[j].requests; let i = index">
            <td scope="row">{{ req?.nid }}</td>
            <td class="ar">{{ req?.business?.nomCommercial }}</td>
            <td>{{ req?.business?.tel }}</td>
            <td class="ar">{{ req?.business?.address }}</td>
            <td>{{ req?.amount }}DT</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<iframe
  class="d-none"
  frameBorder="0"
  id="sample-pdf"
  style="right: 0; top: 53px; bottom: 0; height: 400px; width: 100%"
></iframe>

<a id="pdf-download-link" title="Download PDF File">Download PDF file</a>
